import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/vendor-request';
import {
  Container,
  HeadingTitle,
  HeaderFlexRow,
  ControlWrapper,
  SearchWrapper,
} from 'components/styled-components';
import Pagination from 'components/pagination';
import { IconNames } from '@blueprintjs/icons';
import { InputGroup } from '@blueprintjs/core';
import RenewalsTable from 'components/renewals/renewals-table';
import debounce from 'lodash/debounce';
import constants from 'utils/constants';

class ManageRenewals extends Component {
  state = {
    query: '',
    data: { totalCount: 0, result: [] },
    currentPage: 0,
    perPage: 10,
  };

  componentDidMount() {
    const params = { start: 0, limit: -1, renewalsWithinDays: 60 };
    this.props.fetchAllUpcomingRenewalVendorRequests({ ...params });
  }

  buildParams = (query, start, limit) => {
    query = query.trim();
    return query
      ? {
          start: start || 0,
          limit: limit || -1,
          renewalsWithinDays: 60,
          searchQuery: query,
        }
      : {
          start: start || 0,
          limit: limit || -1,
          renewalsWithinDays: 60,
        };
  };

  handleSearch = params => {
    this.props.fetchAllUpcomingRenewalVendorRequests({ ...params });
  };

  throttledSearch = debounce(
    this.handleSearch,
    constants.SEARCH_TYPING_DELAY_MILLISECONDS
  );

  handleQueryChange = e => {
    const query = e.target.value;
    const params = this.buildParams(
      query,
      this.state.currentPage * this.state.perPage,
      this.state.perPage
    );
    this.setState({ query, currentPage: 0 }, () => {
      this.throttledSearch(params);
    });
  };

  handlePageClick = currentPage => {
    this.setState({ currentPage }, () =>
      this.props.fetchAllUpcomingRenewalVendorRequests(
        this.buildParams(
          this.state.query,
          this.state.currentPage * this.state.perPage,
          this.state.perPage
        )
      )
    );
  };

  handlePerPageChange = perPage => {
    this.setState({ perPage: perPage.value, currentPage: 0 }, () =>
      this.props.fetchAllUpcomingRenewalVendorRequests(
        this.buildParams(
          this.state.query,
          this.state.currentPage * this.state.perPage,
          this.state.perPage
        )
      )
    );
  };

  render() {
    const { upcomingRenewals } = this.props;
    const {query} = this.state
    return (
      <Container>
        <HeaderFlexRow>
          <HeadingTitle>Renewals</HeadingTitle>
        </HeaderFlexRow>
        <SearchWrapper>
          <ControlWrapper>
            <InputGroup
              leftIcon={IconNames.SEARCH}
              placeholder={`Search Renewals`}
              onChange={this.handleQueryChange}
              value={this.state.query}
              className="medium-text-group light-blue"
            />
          </ControlWrapper>
        </SearchWrapper>
        <RenewalsTable
          requests={upcomingRenewals.result}
          totalCount={upcomingRenewals.totalCount}
          query={query}
        />
        <Pagination
          numRecords={upcomingRenewals.totalCount}
          perPage={this.state.perPage}
          currentPage={this.state.currentPage}
          onPageClick={this.handlePageClick}
          handlePerPageChange={this.handlePerPageChange}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  upcomingRenewals: state.vendorRequest.allRequestsUpcomingApprovals,
});

ManageRenewals = connect(
  mapStateToProps,
  actions
)(ManageRenewals);

export default ManageRenewals;
